/** @jsxImportSource @emotion/react */
import type { ReactNode } from 'react';
import { Button } from '../../../design-system/atoms/Button/Button';
import { IS_DEV, API_BASE } from '../../config/env';
import {
  headerStyle,
  titleStyle,
  titleGroupStyle,
  devBadgeStyle,
  devBadgeApiStyle,
  rightStyle,
  mutedStyle,
  dividerStyle,
} from './AppHeader.styles';

export interface AppHeaderProps {
  /** 현재 화면 제목. */
  title: ReactNode;
  /** 마지막 갱신 문구. 예: "마지막 갱신 2026-07-30 18:22" */
  lastUpdatedText?: ReactNode;
  userName?: ReactNode;
  onRefresh?: () => void;
  onLogout?: () => void;
}

/** 상단 헤더. 화면 제목, 갱신·로그아웃 액션에 활용. */
export function AppHeader({ title, lastUpdatedText, userName, onRefresh, onLogout }: AppHeaderProps) {
  return (
    <header css={headerStyle}>
      <div css={titleGroupStyle}>
        <h1 css={titleStyle}>{title}</h1>
        {/* 개발 환경에서만 노출 — 운영과 혼동 방지. API base도 함께 표기. */}
        {IS_DEV && (
          <span css={devBadgeStyle}>
            DEV<span css={devBadgeApiStyle}>{API_BASE}</span>
          </span>
        )}
      </div>
      <div css={rightStyle}>
        {lastUpdatedText !== undefined && <span css={mutedStyle}>{lastUpdatedText}</span>}
        <Button variant="outline" tone="neutral" onClick={onRefresh}>
          ↻ 새로고침
        </Button>
        <span css={dividerStyle} />
        {userName !== undefined && <span css={mutedStyle}>{userName} 님</span>}
        <Button variant="outline" tone="neutral" onClick={onLogout}>
          로그아웃
        </Button>
      </div>
    </header>
  );
}
